import { render, staticRenderFns } from "./view8.vue?vue&type=template&id=2231cb08&scoped=true"
import script from "./view8.vue?vue&type=script&lang=js"
export * from "./view8.vue?vue&type=script&lang=js"
import style0 from "./view8.vue?vue&type=style&index=0&id=2231cb08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231cb08",
  null
  
)

export default component.exports